"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalization = exports.useLocalizationLocale = exports.useLocalizationMessages = exports.useLocalizationContext = void 0;
const react_1 = __importStar(require("react"));
const LocalizationContext_1 = require("../context/LocalizationContext");
const messageCode_1 = require("../utils/messageCode");
function useLocalizationContext() {
    return react_1.useContext(LocalizationContext_1.LocalizationContext);
}
exports.useLocalizationContext = useLocalizationContext;
function useLocalizationMessages() {
    const context = useLocalizationContext();
    return (context && context.messages) || {};
}
exports.useLocalizationMessages = useLocalizationMessages;
function useLocalizationLocale() {
    const context = useLocalizationContext();
    return (context && context.locale) || 'en-US';
}
exports.useLocalizationLocale = useLocalizationLocale;
function useLocalization() {
    const messages = useLocalizationMessages();
    return react_1.default.useCallback((code, args) => messageCode_1.getMessage(messages, code, args), [messages]);
}
exports.useLocalization = useLocalization;
//# sourceMappingURL=localization.hooks.js.map